<template>
  <el-dialog :visible.sync="visible" title="申请开票" width="560px" :close-on-click-modal="false" @closed="resetForm">
    <el-form ref="applyForm" :model="applyForm" :rules="applyRules" label-width="90px" class="apply-form">
      <div class="dialog-line">
        <span class="dialog-label">开票金额：</span>
        <span class="dialog-value">{{ formatAmount(activeRow.invoice_amount) }}</span>
      </div>
      <el-form-item label="发票类型" prop="invoiceType">
        <el-radio-group v-model="applyForm.invoiceType">
          <el-radio :label="1">普票</el-radio>
          <el-radio :label="2">专票</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="dialog-line">
        <span class="dialog-label">发票抬头：</span>
        <span class="dialog-value">{{ activeRow.invoice_title || '-' }}</span>
      </div>
      <div class="dialog-line">
        <span class="dialog-label">税号：</span>
        <span class="dialog-value">{{ activeRow.invoice_tax_no || '-' }}</span>
      </div>
      <div class="dialog-line">
        <span class="dialog-label">开票主体：</span>
        <span class="dialog-value">{{ activeRow.invoice_subject || '-' }}</span>
      </div>
      <div class="dialog-line">
        <span class="dialog-label">税号：</span>
        <span class="dialog-value">{{ activeRow.subject_tax_no || '-' }}</span>
      </div>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitApply">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { applyInvoice } from '@/api/invoice'

export default {
  name: 'InvoiceApplyDialog',
  data() {
    return {
      visible: false,
      submitLoading: false,
      activeRow: {},
      currentStatus: '1',
      applyForm: {
        invoiceType: 1
      },
      applyRules: {
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }]
      }
    }
  },
  methods: {
    open(row, status) {
      this.activeRow = Object.assign({}, row || {})
      this.currentStatus = status || '1'
      this.visible = true
    },
    formatAmount(value) {
      const numberValue = Number(value || 0)
      return numberValue.toFixed(2)
    },
    resetForm() {
      this.activeRow = {}
      this.applyForm = {
        invoiceType: 1
      }
      if (this.$refs.applyForm) {
        this.$refs.applyForm.clearValidate()
      }
    },
    submitApply() {
      this.$refs.applyForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        this.submitLoading = true
        const params = {
          id: this.activeRow.id,
          invoice_id: this.activeRow.invoice_id,
          invoice_type: this.applyForm.invoiceType,
          status: this.currentStatus
        }
        try {
          await applyInvoice(params)
          this.$Message.success('开票申请已提交，审核无误后将在7个工作日内完成开票。')
          this.visible = false
          this.$emit('success')
        } catch (error) {
          console.log(error)
        } finally {
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.apply-form {
  padding-right: 18px;
}

.dialog-line {
  margin-bottom: 12px;
  line-height: 22px;
}

.dialog-label {
  color: #17233d;
  font-weight: 500;
}

.dialog-value {
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/invoice/modules/ApplyDialog.vue